import { CombinedState } from '@reduxjs/toolkit';
import { RootStateType } from 'App/store';
import { convertStatusTypeToObject } from 'commons/utils/convertStatusTypeToObject';
import createSimpleSelector from 'commons/utils/createSimpleSelector';
import { PriceTablesInterface } from '../types';

export const getPriceTablesState = (
  state: RootStateType,
): CombinedState<PriceTablesInterface> => state.customers.priceTables;

export const getPriceTablesData = createSimpleSelector(
  [getPriceTablesState],
  (state) => state.priceTables.data,
);

export const getPriceTablesStatus = createSimpleSelector(
  [getPriceTablesState],
  (state) => convertStatusTypeToObject(state.priceTables.status),
);
